import { Skeleton, Stack } from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

import { Cell, CellFrame } from '@/core/architecture'

type DmRoomMessageProps = {}

export const DmRoomMessageSkeleton: Cell<DmRoomMessageProps> = ({}) =>
  [1, 2, 3].map(key => <DmRoomMessageBoxSkeleton key={key} />)

type DmRoomMessageBoxProps = {}

const DmRoomMessageBoxSkeleton: Cell<DmRoomMessageBoxProps> = ({}) => (
  <>
    <CellFrame>
      <Stack sx={{ py: 5 }}>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ pb: 2 }}>
          <Stack>
            <Skeleton variant="circular" width={28} height={28} />
          </Stack>
          <SkeletonText variant="small" width="25%" />
        </Stack>
        <SkeletonText
          variant="small"
          numberOfLine={2}
          width="60%"
          lastWidth="60%"
        />
      </Stack>
    </CellFrame>
    <CellFrame>
      <Stack sx={{ py: 5 }}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          sx={{ pb: 2, justifyContent: 'flex-end' }}
        >
          <SkeletonText variant="small" width="25%" />
          <Stack>
            <Skeleton variant="circular" width={28} height={28} />
          </Stack>
        </Stack>
        <Stack sx={{ alignItems: 'flex-end' }}>
          <SkeletonText
            variant="small"
            numberOfLine={2}
            width="60%"
            lastWidth="60%"
          />
        </Stack>
      </Stack>
    </CellFrame>
  </>
)
